import React, { useEffect } from 'react';

export function useOnClickOutside(
  refs: React.MutableRefObject<HTMLElement | null>[] | React.MutableRefObject<HTMLElement | null>,
  handler?: (event: TouchEvent | MouseEvent) => void
) {
  useEffect(() => {
    const listener = (event: any) => {
      let resultRefs: React.MutableRefObject<HTMLElement | null>[] = [];
      if (Array.isArray(refs)) {
        resultRefs = refs as React.MutableRefObject<HTMLElement | null>[];
      } else {
        resultRefs = [refs as React.MutableRefObject<HTMLElement | null>];
      }

      if (
        resultRefs.some(
          ref => !document.body.contains(event.target) || !ref.current || ref.current.contains(event.target)
        )
      ) {
        return;
      }

      handler?.(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [refs, handler]);
}
